import { render, staticRenderFns } from "./MarkdownContainer.vue?vue&type=template&id=51adc864&"
import script from "./MarkdownContainer.vue?vue&type=script&setup=true&lang=js&"
export * from "./MarkdownContainer.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports